import { queryOptions, useQuery } from "@tanstack/react-query";
import bomBrandOriginService from "../services/bom-brand-origin-service";

export const bomBrandOriginsQueryOptions = () =>
    queryOptions({
        queryKey: ["bom-brand-origins"],
        queryFn: () => bomBrandOriginService.list(),
        staleTime: 1000 * 60 * 60,
    });

export const useBomBrandOrigins = () => useQuery(bomBrandOriginsQueryOptions());

export const useBomBrandOriginOptions = () => {
    const query = useBomBrandOrigins();
    const options = (query.data ?? []).map((origin) => ({
        value: origin.brand_origin_name,
        label: origin.brand_origin_name,
    }));
    return { ...query, options };
};
